import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { ReactComponent as Checkmark } from '../../../../../assets/icons/checkmark.svg'
import {
    INLUDataExample,
    useNLUDataStore,
} from '../../../../../stores/nluDataStore'

import styles from './message-form.module.scss'

interface IMessageFormProps {
    setIsMessageEditing: React.Dispatch<React.SetStateAction<boolean>>
    example: INLUDataExample
}

function MessageForm(props: IMessageFormProps) {
    const { setIsMessageEditing, example } = props
    const { _id, text } = example

    const { t } = useTranslation()

    const { tab } = useParams()

    const inputRef = useRef<HTMLInputElement>(null)

    const [newMessage, setNewMessage] = useState(text)

    const [, { editExampleMessage }] = useNLUDataStore()

    useEffect(() => {
        setNewMessage(text)
    }, [text])

    useEffect(() => {
        if (inputRef?.current) {
            inputRef.current.focus()
        }
    }, [])

    const handleMessageFormSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault()
        setIsMessageEditing(false)

        if (newMessage === text) {
            return
        }

        tab && editExampleMessage(tab, _id, newMessage)
    }

    return (
        <form className={styles.messageForm} onSubmit={handleMessageFormSubmit}>
            <input
                ref={inputRef}
                className={styles.messageForm__input}
                type="text"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
            />
            <button className={styles.messageForm__button} type="submit">
                <Checkmark
                    alt={t('save')}
                    className={styles.messageForm__icon}
                />
            </button>
        </form>
    )
}

export default MessageForm
